import qs from 'qs';
import { Interval, DateTime } from 'luxon';
import { pickBy, identity } from 'lodash';

class BitriseClientApi {
  constructor(discoveryApi, fetchApi) {
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi;
  }
  async getArtifactDetails(appSlug, buildSlug, artifactSlug) {
    const baseUrl = await this.discoveryApi.getBaseUrl("proxy");
    const artifactResponse = await this.fetchApi.fetch(
      `${baseUrl}/bitrise/apps/${appSlug}/builds/${buildSlug}/artifacts/${artifactSlug}`
    );
    const data = await artifactResponse.json();
    return data.data;
  }
  async getBuildArtifacts(appSlug, buildSlug) {
    const baseUrl = await this.discoveryApi.getBaseUrl("proxy");
    const response = await this.fetchApi.fetch(
      `${baseUrl}/bitrise/apps/${appSlug}/builds/${buildSlug}/artifacts`
    );
    const data = await response.json();
    return data.data;
  }
  async getAppsPaginated(from) {
    const baseUrl = await this.discoveryApi.getBaseUrl("proxy");
    const appsResponse = await this.fetchApi.fetch(
      `${baseUrl}/bitrise/apps?next=${from}`
    );
    const appsData = await appsResponse.json();
    if (appsData.paging?.next) {
      return appsData.data.concat(
        await this.getAppsPaginated(appsData.paging.next)
      );
    }
    return appsData.data;
  }
  async getApps() {
    return await this.getAppsPaginated("");
  }
  async getApp(appName) {
    const apps = await this.getApps();
    return apps.find((app) => app.title === appName);
  }
  async getBuildWorkflows(appSlug) {
    const baseUrl = await this.discoveryApi.getBaseUrl("proxy");
    const response = await this.fetchApi.fetch(
      `${baseUrl}/bitrise/apps/${appSlug}/build-workflows`
    );
    const data = await response.json();
    return data.data;
  }
  async getBuilds(appSlug, params) {
    const baseUrl = await this.discoveryApi.getBaseUrl("proxy");
    let url = `${baseUrl}/bitrise/apps/${appSlug}/builds`;
    if (params) {
      url = `${url}?${qs.stringify(pickBy(params, identity))}`;
    }
    const response = await this.fetchApi.fetch(url);
    const data = await response.json();
    const builds = data.data;
    return {
      data: builds.map(
        (build) => {
          const duration = String(
            Math.round(
              Interval.fromDateTimes(
                DateTime.fromISO(build.started_on_worker_at),
                DateTime.fromISO(build.finished_at)
              ).length("minutes")
            )
          );
          return {
            id: build.build_number,
            source: build.commit_view_url,
            status: build.status,
            statusText: build.status_text,
            buildSlug: build.slug,
            message: `${build.branch}`,
            workflow: build.triggered_workflow,
            commitHash: `${build.commit_hash}`,
            triggerTime: build.triggered_at,
            duration: `${duration} minutes`,
            appSlug
          };
        }
      ),
      paging: data.paging
    };
  }
}

export { BitriseClientApi };
//# sourceMappingURL=bitriseApi.client.esm.js.map
